import axios from '../utils/axios'

// 我的信息
export function SaleMiniAppMyInfoGet(params = {}) {
  return axios({
    url: '/Member/SApp/SaleMiniAppMyInfoGet',
    method: 'get',
    params: params
  })
}

// 获取余额列表
export function SAppAmountInfoListGet(params = {}) {
  return axios({
    url: '/Member/SApp/SAppAmountInfoListGet',
    method: 'get',
    params: params
  })
}

// 银行卡解绑接口
export function DeleteBankCardInfo(params = {}) {
  return axios({
    url: '/Member/SApp/DeleteBankCardInfo',
    method: 'post',
    params: params
  })
}

// 获取待返金额列表
export function AmountBackListGet(params = {}) {
  return axios({
    url: '/Member/SApp/SaleAmountBackList',
    method: 'get',
    params: params
  })
}

// 获取余额明细详情
export function SAppAmountInfoGet(params = {}) {
  return axios({
    url: '/Member/SApp/SAppAmountInfoGet',
    method: 'get',
    params: params
  })
}

// 获取待返金额明细详情
export function SaleAmounBackInfoGet(params = {}) {
  return axios({
    url: '/Member/SApp/SaleAmounBackInfoGet',
    method: 'get',
    params: params
  })
}

// // 上架提醒列表
// export function ProductRemindList (params = {}) {
//   return axios({
//     url: '/Sale/Task/ProductRemindList',
//     method: 'get',
//     params: params
//   })
// }

// // 取消上架提醒
// export function ProductRemindCancel (data = {}) {
//   return axios({
//     url: '/Sale/Task/ProductRemindCancel',
//     method: 'post',
//     data: data
//   })
// }

// 余额提现-金额
export function TransferAccountsBasicInfoGet(params = {}) {
  return axios({
    url: '/Member/SApp/TransferAccountsBasicInfoGet',
    method: 'get',
    params: params
  })
}

// 余额提现-列表
export function TransferAccountInfoListGet(params = {}) {
  return axios({
    url: '/Member/SApp/TransferAccountInfoListGet',
    method: 'get',
    params: params
  })
}

// 余额提现-银行卡确认手续费接口
export function BankCardConfirmPoundage(params = {}) {
  return axios({
    url: '/Member/TransferAccounts/BankCardConfirmPoundage',
    method: 'post',
    params: params
  })
}

// 余额提现-绑定银行卡-获取银行信息
export function GetBankCardInfo(params = {}) {
  return axios({
    url: '/Member/SApp/GetBankCardInfo',
    method: 'get',
    params: params
  })
}
// 余额提现-绑定银行卡-绑定提交
export function SubmitBankCardInfo(data = {}) {
  return axios({
    url: '/Member/SApp/SubmitBankCardInfo',
    method: 'post',
    data: data
  })
}

// 余额提现-支付宝-绑定提交
export function EditAlipayNo(data = {}) {
  return axios({
    url: '/Member/AlipayTransferAccounts/EditAlipayNo',
    method: 'post',
    data: data
  })
}

// 我的订单-全部
export function EvaluateAllInfo(params = {}) {
  return axios({
    url: '/Sale/Task/EvaluateAllInfo',
    method: 'get',
    params: params
  })
}

// 我的订单-待完成
export function SaleTaskToCompleteList(params = {}) {
  return axios({
    url: '/Sale/Task/SaleTaskToCompleteList',
    method: 'get',
    params: params
  })
}

// 我的订单-待收货
export function SaleWaitReceiveList(params = {}) {
  return axios({
    url: '/Sale/Task/SaleWaitReceiveList',
    method: 'get',
    params: params
  })
}

// 我的订单-已完成
export function FinishEvaluateInfo(params = {}) {
  return axios({
    url: '/Sale/Task/FinishEvaluateInfo',
    method: 'get',
    params: params
  })
}

// 我的订单-已退款
export function SaleTaskRefundList(params = {}) {
  return axios({
    url: '/Sale/Task/SaleTaskRefundList',
    method: 'get',
    params: params
  })
}

// 我的订单-确认收货(领取返利)
export function ReceiveConfirm(data = {}) {
  return axios({
    url: '/Sale/Task/ReceiveConfirm',
    method: 'post',
    data: data
  })
}

// 我的订单-拼多多确认收货(领取返利)
export function PddReceiveConfirm(data = {}) {
  return axios({
    url: '/Sale/Task/PddReceiveConfirm',
    method: 'post',
    data: data
  })
}

// 我的订单-京东确认收货(领取返利)
export function JdReceiveConfirm(data = {}) {
  return axios({
    url: '/Sale/Task/JdReceiveConfirm',
    method: 'post',
    data: data
  })
}

// 我的订单-抖音确认收货(领取返利)
export function DouDianReceiveConfirm(data = {}) {
  return axios({
    url: '/Sale/Task/DouDianReceiveConfirm',
    method: 'post',
    data: data
  })
}

// 我的订单-抖音确认收货(领取返利)
export function TgcReceiveConfirm(data = {}) {
  return axios({
    url: '/Sale/Task/TgcReceiveConfirm',
    method: 'post',
    data: data
  })
}

// 我的订单-取消订单/取消购买
export function CancelSaleTaskAccept(data = {}) {
  return axios({
    url: '/Sale/Task/CancelSaleTaskAccept',
    method: 'post',
    data: data
  })
}

// 我的订单-取消反馈
export function SpreadFeedbackCancel(data) {
  return axios({
    url: '/Sale/Task/SpreadFeedbackCancel',
    method: 'post',
    data: data
  })
}

// 获取差价反馈审核结果接口
export function GetSpreadFeedbackAuditInfo(params = {}) {
  return axios({
    url: '/Sale/Task/GetSpreadFeedbackAuditInfo',
    method: 'get',
    params: params
  })
}

// 我的优惠券
export function MyCouponList(params = {}) {
  return axios({
    url: '/Member/SApp/MyCouponList',
    method: 'get',
    params: params
  })
}

// 我的-待领取免单卡
export function WaitGetFreeCarNum(params = {}) {
  return axios({
    url: '/SaleV2/FreeCard/WaitGetFreeCarNum',
    method: 'get',
    params: params
  })
}

// 邀请好友赠送卡数
export function GetRecommendSendQty(params = {}) {
  return axios({
    url: '/Member/RecommendCycle/GetRecommendSendQty',
    method: 'get',
    params: params
  })
}

// 获取用户信息详情
export function GetSAppInfo(params) {
  return axios({
    url: '/Member/SApp/GetSAppInfo',
    method: 'get',
    params: params
  })
}

// 违规扣分记录
export function ViolationpPunishRecordList(params) {
  return axios({
    url: '/Member/SApp/ViolationpPunishRecordList',
    method: 'get',
    params: params
  })
}

// 获取用户当前行为分数接口
export function GetBehaviorScoreInfo(params) {
  return axios({
    url: '/Member/Sapp/GetBehaviorScoreInfo',
    method: 'get',
    params: params
  })
}

// 获取行为分变化明细
export function BehaviorScoreLogIndexData(data = {}) {
  return axios({
    url: '/Member/Sapp/BehaviorScoreLogIndexData',
    method: 'post',
    data: data
  })
}

// 待处理事项
export function WaitDoneList(params) {
  return axios({
    url: '/Member/SApp/WaitDoneList',
    method: 'get',
    params: params
  })
}

// 待完成、待收货、评价邀请数字相加和
export function OrderWaitHandleNum(params) {
  return axios({
    url: '/Member/SApp/OrderWaitHandleNum',
    method: 'get',
    params: params
  })
}

// 我的成就数据
export function GetMemberAchievementsInfo(params) {
  return axios({
    url: '/Member/SApp/GetMemberAchievementsInfo',
    method: 'get',
    params: params
  })
}

// 点击限制购买判断
export function OnClickLimitCheck(params) {
  return axios({
    url: '/Member/SApp/OnClickLimitCheck',
    method: 'get',
    params: params
  })
}

// 获取APP吐槽入口开关配置接口
export function GetRidiculeEntranceCfg(params = {}) {
  return axios({
    url: '/Member/SApp/GetRidiculeEntranceCfg',
    method: 'get',
    params: params
  })
}
